import { Container } from '@printdeal/ui-library';
import ErrorBoundaryBody from './ErrorBoundaryBody';
import Logo from '../navigation/header-new/Logo';

const ErrorLayout = () => (
  <Container className="pd:mx-auto">
    <div className="pd:relative pd:grid pd:gap-4 pd:bg-white pd:pt-5">
      <Logo />
      <ErrorBoundaryBody />
    </div>
  </Container>
);

export default ErrorLayout;
